import { HttpRequest, HttpEvent, HttpHandlerFn } from '@angular/common/http';
import { Observable } from 'rxjs';
import { inject } from '@angular/core';

import { ApplicationsService } from '../../services/applications/applications.service';

export function applicationIdInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<any>> {
    const applicationsService = inject(ApplicationsService);

    req = req.clone({
        headers: req.headers.set('application-id', applicationsService.applicationIdSelected.toString())
    });

    return next(req);
}
